import React, { useState } from 'react';
import '../styles/LawAppointment.css';

const CsProjectsAppointment = () => {
  const [formData, setFormData] = useState({
    name: '',
    college: '',
    email: '',
    mobile: '',
    researchArea: '',
    projectLevel: '',
    selectedSlot: '',
  });

  const [disabledSlots, setDisabledSlots] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');

  const morningSlots = [
    { slot: 'M1', label: 'Slot 1', time: '7:00 - 7:20 AM' },
    { slot: 'M2', label: 'Slot 2', time: '7:20 - 7:40 AM' },
    { slot: 'M3', label: 'Slot 3', time: '7:40 - 8:00 AM' },
    { slot: 'M4', label: 'Slot 4', time: '8:00 - 8:20 AM' },
    { slot: 'M5', label: 'Slot 5', time: '8:20 - 8:40 AM' },
    { slot: 'M6', label: 'Slot 6', time: '8:40 - 9:00 AM' },
  ];

  const eveningSlots = [
    { slot: 'E1', label: 'Slot 1', time: '6:30 - 6:50 PM' },
    { slot: 'E2', label: 'Slot 2', time: '6:50 - 7:10 PM' },
    { slot: 'E3', label: 'Slot 3', time: '7:10 - 7:30 PM' },
    { slot: 'E4', label: 'Slot 4', time: '7:30 - 7:50 PM' },
    { slot: 'E5', label: 'Slot 5', time: '7:50 - 8:10 PM' },
    { slot: 'E6', label: 'Slot 6', time: '8:10 - 8:30 PM' },
  ];

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSlotSelect = (slotId) => {
    if (disabledSlots.includes(slotId)) return;
    setFormData({ ...formData, selectedSlot: slotId });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.selectedSlot) {
      alert('Please select a time slot.');
      return;
    }

    const orderId = `CSPROJ-${Date.now()}`;

    try {
      setIsLoading(true);
      const paymentRes = await fetch('/api/payment/create-session', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          mobile: formData.mobile,
          orderId,
          type: 'csprojects',
          appointmentData: formData,
        }),
      });

      const paymentData = await paymentRes.json();

      if (paymentData?.payment_links?.web) {
        setDisabledSlots((prev) => [...prev, formData.selectedSlot]);
        window.location.href = paymentData.payment_links.web;
      } else {
        alert('Payment failed: No payment link received.');
      }
    } catch (error) {
      console.error('Payment error:', error);
      alert('Something went wrong. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="law-appointment-wrapper">
      <div className="law-content">

        {/* Terms & Conditions */}
        <div className="law-terms-box">
          <h3>📌 Terms and Conditions</h3>
          <ul>
            <li>Once the payment is completed, <strong style={{ color: 'red' }}>the amount will <u>not be refunded</u></strong> under any circumstances.</li>
            <li>Ensure all details entered are <strong>accurate</strong> before proceeding.</li>
            <li>Appointment slots are confirmed only after successful payment.</li>
            <li>Slot changes allowed only in <strong>exceptional cases</strong>.</li>
            <li>Contact support within <strong>24 hours</strong> for technical issues.</li>
          </ul>
        </div>

        {/* Form */}
        <div className="law-form-card">
          <form onSubmit={handleSubmit}>
            <input name="name" placeholder="Full Name" value={formData.name} onChange={handleChange} required />
            <input name="college" placeholder="College Name" value={formData.college} onChange={handleChange} required />
            <input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} required />
            <input type="tel" name="mobile" placeholder="Mobile Number" value={formData.mobile} onChange={handleChange} required />

            <select name="researchArea" value={formData.researchArea} onChange={handleChange} required>
              <option value="">-- Select Research Area --</option>
              <option value="ai">Artificial Intelligence</option>
              <option value="ml">Machine Learning</option>
              <option value="iot">IoT</option>
              <option value="ds">Data Science</option>
              <option value="others">Others</option>
            </select>

            <select name="projectLevel" value={formData.projectLevel} onChange={handleChange} required>
              <option value="">-- Project Level --</option>
              <option value="ug">UG</option>
              <option value="pg">PG</option>
              <option value="phd">PhD</option>
            </select>

            {/* Time Slots */}
            <div className="time-slot-section">
              <div className="slots-group">
                <h4>Morning Slots</h4>
                <div className="slots">
                  {morningSlots.map(({ slot, label, time }) => (
                    <button
                      key={slot}
                      type="button"
                      className={`slot-button ${formData.selectedSlot === slot ? 'selected' : ''}`}
                      onClick={() => handleSlotSelect(slot)}
                      disabled={disabledSlots.includes(slot)}
                      title={time}
                    >
                      {label}
                    </button>
                  ))}
                </div>
              </div>

              <div className="slots-group">
                <h4>Evening Slots</h4>
                <div className="slots">
                  {eveningSlots.map(({ slot, label, time }) => (
                    <button
                      key={slot}
                      type="button"
                      className={`slot-button ${formData.selectedSlot === slot ? 'selected' : ''}`}
                      onClick={() => handleSlotSelect(slot)}
                      disabled={disabledSlots.includes(slot)}
                      title={time}
                    >
                      {label}
                    </button>
                  ))}
                </div>
              </div>
            </div>

            <p style={{ fontWeight: 'bold', marginTop: '8px', color: '#333' }}>Appointment Fee ₹100</p>
            <button type="submit" disabled={isLoading}>
              {isLoading ? 'Processing...' : 'Book Appointment'}
            </button>
            {message && <p className="error">{message}</p>}
          </form>
        </div>

      </div>
    </div>
  );
};

export default CsProjectsAppointment;
